(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function initBlessedMobileMenu() {
    const header = document.querySelector('.blessed-header-shell');
    if (!header) return;

    const toggle = header.querySelector('.blessed-header__menu-toggle');
    const menu = document.querySelector('.blessed-header__mobile-menu');
    const closeBtn = document.querySelector('.blessed-header__mobile-close');

    if (!toggle || !menu) return;

    const openMenu = () => {
      menu.classList.add('blessed-header__mobile-menu--open');
      document.documentElement.classList.add('blessed-header--menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
    };

    const closeMenu = () => {
      menu.classList.remove('blessed-header__mobile-menu--open');
      document.documentElement.classList.remove('blessed-header--menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
    };

    toggle.addEventListener('click', () => {
      const isOpen = menu.classList.contains('blessed-header__mobile-menu--open');
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.classList.contains('blessed-header__mobile-menu--open')) {
        closeMenu();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlessedMobileMenu);
  } else {
    initBlessedMobileMenu();
  }

  } catch(e) { console.error(e); }
})();
})();
